module.exports = __webpack_public_path__ + "images/null-media.1a1b695e8f6e2b8b5a9ea999be538c74.png";